import React from "react";

/**
 * Brushed-gold hairline divider — replaces every <hr /> with editorial polish.
 *
 * Variants:
 *   default  — fades transparent → gold → transparent. Works on light or dark.
 *   ornament — same hairline with a small centred medallion glyph (★) for
 *              major section breaks. Use sparingly, once or twice per page.
 *
 * Usage:
 *   <GoldDivider />
 *   <GoldDivider variant="ornament" />
 */
export const GoldDivider = ({ variant = "default", className = "" }) => {
  if (variant === "ornament") {
    return (
      <div
        role="separator"
        aria-hidden="true"
        data-testid="gold-divider-ornament"
        className={`flex items-center gap-4 my-10 ${className}`}
      >
        <span className="flex-1 h-px bg-gold-hairline" />
        <span className="font-spectral text-gold/80 text-xl leading-none">✦</span>
        <span className="flex-1 h-px bg-gold-hairline" />
      </div>
    );
  }
  return (
    <div
      role="separator"
      aria-hidden="true"
      data-testid="gold-divider"
      className={`gold-hairline ${className}`}
    />
  );
};

export default GoldDivider;
